import { useCallback, useSyncExternalStore } from "react";

/**
 * Certaines bascules de mise en page doivent être portées par React et non par
 * la CSS : un `display: none` ne peut ni s'animer ni retirer un bloc du flux
 * pendant sa sortie. La lecture est synchrone au premier rendu, sinon la
 * présentation apparaîtrait une image avant d'être remplacée par le formulaire.
 */
export const useMediaQuery = (query: string): boolean => {
  const subscribe = useCallback(
    (onChange: () => void) => {
      const list = window.matchMedia(query);
      list.addEventListener("change", onChange);
      return () => list.removeEventListener("change", onChange);
    },
    [query],
  );

  return useSyncExternalStore(subscribe, () => window.matchMedia(query).matches);
};
